/**
 * AI Gateway guard (Sprint 288 Stream E; REQ-GW-010).
 *
 * The Developers section is hidden without ``Module:ai_gateway#view`` and a
 * direct URL resolves to a denial page with no data fetched. ``useModuleAccess``
 * is fail-closed (SEC-003).
 */

import type { ReactNode } from 'react';
import { ShieldAlert } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui';
import { useModuleAccess } from '@/hooks/useModuleAccess';
import { useI18n } from '@/i18n';

export function GatewayGuard({ children }: { children: ReactNode }) {
  const { t } = useI18n();
  const canView = useModuleAccess('ai_gateway', 'view');

  if (!canView) {
    return (
      <div className="p-6" data-testid="gateway-denied">
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <ShieldAlert className="h-5 w-5 text-amber-500" aria-hidden="true" />
              {t('gateway.denied.title')}
            </CardTitle>
          </CardHeader>
          <CardContent>
            <p className="text-sm text-gray-600 dark:text-gray-300">
              {t('gateway.denied.message')}
            </p>
          </CardContent>
        </Card>
      </div>
    );
  }
  return <>{children}</>;
}
